import type { RequestKind } from '@magimp/shared';

// WHY (#1393/#1448): SIMPLE (#1306), CONTAINER (#1393), and now STANDARD
//   (#1448) all hide the insurance card, so their save/send/completeness
//   paths must force the insurance triplet off (or omit it) and never block
//   on it. Every current kind hides insurance; the function stays as the
//   single source of truth so a future kind that revives the card flips
//   exactly one place. The `kind` parameter is retained for that future
//   per-kind branch and to keep call sites self-documenting.
export function kindHidesInsurance(_kind: RequestKind): boolean {
  return true;
}
